// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file router/router_responses.proto (package com.gem.router.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

import type { DestinationType, MatchedBy } from './router_requests_pb';
import { file_router_router_requests } from './router_requests_pb';

/**
 * Describes the file router/router_responses.proto.
 */
export const file_router_router_responses: GenFile =
  /*@__PURE__*/
  fileDesc(
    'Ch1yb3V0ZXIvcm91dGVyX3Jlc3BvbnNlcy5wcm90bxIXY29tLmdlbS5yb3V0ZXIuY29udHJhY3QiSAoOUm91dGVyUmVzcG9uc2USNgoHc3VjY2VzcxgBIAEoCzIlLmNvbS5nZW0ucm91dGVyLmNvbnRyYWN0LlJlc3BvbnNlRGF0YSJaCgxSZXNwb25zZURhdGESEgoKZG9tYWluTmFtZRgBIAEoCRI2Cgdjb25maWdzGAIgAygLMiUuY29tLmdlbS5yb3V0ZXIuY29udHJhY3QuVGVuYW50Q29uZmlnIn4KDFRlbmFudENvbmZpZxIVCg1kb21haW5SZXN0VXJsGAEgASgJEhcKD2RvbWFpblNvY2tldFVybBgCIAEoCRIbChNkb21haW5DYWxsU29ja2V0VXJsGAMgASgJEiEKGWRvbWFpblVuYXV0aG9yaXplZENhbGxVcmwYBCABKAkiWwoYR2V0UmVnaW9uQmFzZVVybFJlc3BvbnNlEj8KB3N1Y2Nlc3MYASABKAsyLi5jb20uZ2VtLnJvdXRlci5jb250cmFjdC5SZWdpb25CYXNlVXJsUmVzcG9uc2UiKwoVUmVnaW9uQmFzZVVybFJlc3BvbnNlEhIKCmJmZkJhc2VVcmwYASABKAkiZwoeR2V0QWxsQXZhaWxhYmxlUmVnaW9uc1Jlc3BvbnNlEkUKB3N1Y2Nlc3MYASABKAsyNC5jb20uZ2VtLnJvdXRlci5jb250cmFjdC5BbGxBdmFpbGFibGVSZWdpb25zUmVzcG9uc2UiMQobQWxsQXZhaWxhYmxlUmVnaW9uc1Jlc3BvbnNlEhIKCnJlZ2lvbk5hbWUYASADKAkiTAoQRGlzY292ZXJSZXNwb25zZRI4CgdzdWNjZXNzGAEgASgLMicuY29tLmdlbS5yb3V0ZXIuY29udHJhY3QuRGlzY292ZXJSZXN1bHQiVAoORGlzY292ZXJSZXN1bHQSQgoMZGVzdGluYXRpb25zGAEgAygLMiwuY29tLmdlbS5yb3V0ZXIuY29udHJhY3QuRGlzY292ZXJEZXN0aW5hdGlvbiKUAgoTRGlzY292ZXJEZXN0aW5hdGlvbhI2CgR0eXBlGAEgASgOMiguY29tLmdlbS5yb3V0ZXIuY29udHJhY3QuRGVzdGluYXRpb25UeXBlEhIKBWFsaWFzGAMgASgJSACIAQESOgoJbWF0Y2hlZEJ5GAUgASgOMiIuY29tLmdlbS5yb3V0ZXIuY29udHJhY3QuTWF0Y2hlZEJ5SAGIAQESGQoMbWF0Y2hlZFZhbHVlGAYgASgJSAKIAQFCCAoGX2FsaWFzQgwKCl9tYXRjaGVkQnlCDwoNX21hdGNoZWRWYWx1ZUoECAIQA0oECAQQBUoECAcQCFIHYmFzZVVybFIOaW5zdGFsbGF0aW9uSWRSBnJlZ2lvbiJaChdEaXNjb3ZlckJhc2VVcmxSZXNwb25zZRI/CgdzdWNjZXNzGAEgASgLMi4uY29tLmdlbS5yb3V0ZXIuY29udHJhY3QuRGlzY292ZXJCYXNlVXJsUmVzdWx0IigKFURpc2NvdmVyQmFzZVVybFJlc3VsdBIPCgdiYXNlVXJsGAEgASgJQhsKF2NvbS5nZW0ucm91dGVyLmNvbnRyYWN0UAFiBnByb3RvMw',
    [file_router_router_requests]
  );

/**
 * @generated from message com.gem.router.contract.RouterResponse
 */
export type RouterResponse = Message<'com.gem.router.contract.RouterResponse'> & {
  /**
   * @generated from field: com.gem.router.contract.ResponseData success = 1;
   */
  success?: ResponseData;
};

/**
 * Describes the message com.gem.router.contract.RouterResponse.
 * Use `create(RouterResponseSchema)` to create a new message.
 */
export const RouterResponseSchema: GenMessage<RouterResponse> =
  /*@__PURE__*/
  messageDesc(file_router_router_responses, 0);

/**
 * @generated from message com.gem.router.contract.ResponseData
 */
export type ResponseData = Message<'com.gem.router.contract.ResponseData'> & {
  /**
   * @generated from field: string domainName = 1;
   */
  domainName: string;

  /**
   * @generated from field: repeated com.gem.router.contract.TenantConfig configs = 2;
   */
  configs: TenantConfig[];
};

/**
 * Describes the message com.gem.router.contract.ResponseData.
 * Use `create(ResponseDataSchema)` to create a new message.
 */
export const ResponseDataSchema: GenMessage<ResponseData> =
  /*@__PURE__*/
  messageDesc(file_router_router_responses, 1);

/**
 * @generated from message com.gem.router.contract.TenantConfig
 */
export type TenantConfig = Message<'com.gem.router.contract.TenantConfig'> & {
  /**
   * @generated from field: string domainRestUrl = 1;
   */
  domainRestUrl: string;

  /**
   * @generated from field: string domainSocketUrl = 2;
   */
  domainSocketUrl: string;

  /**
   * @generated from field: string domainCallSocketUrl = 3;
   */
  domainCallSocketUrl: string;

  /**
   * @generated from field: string domainUnauthorizedCallUrl = 4;
   */
  domainUnauthorizedCallUrl: string;
};

/**
 * Describes the message com.gem.router.contract.TenantConfig.
 * Use `create(TenantConfigSchema)` to create a new message.
 */
export const TenantConfigSchema: GenMessage<TenantConfig> =
  /*@__PURE__*/
  messageDesc(file_router_router_responses, 2);

/**
 * @generated from message com.gem.router.contract.GetRegionBaseUrlResponse
 */
export type GetRegionBaseUrlResponse =
  Message<'com.gem.router.contract.GetRegionBaseUrlResponse'> & {
    /**
     * @generated from field: com.gem.router.contract.RegionBaseUrlResponse success = 1;
     */
    success?: RegionBaseUrlResponse;
  };

/**
 * Describes the message com.gem.router.contract.GetRegionBaseUrlResponse.
 * Use `create(GetRegionBaseUrlResponseSchema)` to create a new message.
 */
export const GetRegionBaseUrlResponseSchema: GenMessage<GetRegionBaseUrlResponse> =
  /*@__PURE__*/
  messageDesc(file_router_router_responses, 3);

/**
 * @generated from message com.gem.router.contract.RegionBaseUrlResponse
 */
export type RegionBaseUrlResponse = Message<'com.gem.router.contract.RegionBaseUrlResponse'> & {
  /**
   * @generated from field: string bffBaseUrl = 1;
   */
  bffBaseUrl: string;
};

/**
 * Describes the message com.gem.router.contract.RegionBaseUrlResponse.
 * Use `create(RegionBaseUrlResponseSchema)` to create a new message.
 */
export const RegionBaseUrlResponseSchema: GenMessage<RegionBaseUrlResponse> =
  /*@__PURE__*/
  messageDesc(file_router_router_responses, 4);

/**
 * @generated from message com.gem.router.contract.GetAllAvailableRegionsResponse
 */
export type GetAllAvailableRegionsResponse =
  Message<'com.gem.router.contract.GetAllAvailableRegionsResponse'> & {
    /**
     * @generated from field: com.gem.router.contract.AllAvailableRegionsResponse success = 1;
     */
    success?: AllAvailableRegionsResponse;
  };

/**
 * Describes the message com.gem.router.contract.GetAllAvailableRegionsResponse.
 * Use `create(GetAllAvailableRegionsResponseSchema)` to create a new message.
 */
export const GetAllAvailableRegionsResponseSchema: GenMessage<GetAllAvailableRegionsResponse> =
  /*@__PURE__*/
  messageDesc(file_router_router_responses, 5);

/**
 * @generated from message com.gem.router.contract.AllAvailableRegionsResponse
 */
export type AllAvailableRegionsResponse =
  Message<'com.gem.router.contract.AllAvailableRegionsResponse'> & {
    /**
     * @generated from field: repeated string regionName = 1;
     */
    regionName: string[];
  };

/**
 * Describes the message com.gem.router.contract.AllAvailableRegionsResponse.
 * Use `create(AllAvailableRegionsResponseSchema)` to create a new message.
 */
export const AllAvailableRegionsResponseSchema: GenMessage<AllAvailableRegionsResponse> =
  /*@__PURE__*/
  messageDesc(file_router_router_responses, 6);

/**
 * @generated from message com.gem.router.contract.DiscoverResponse
 */
export type DiscoverResponse = Message<'com.gem.router.contract.DiscoverResponse'> & {
  /**
   * @generated from field: com.gem.router.contract.DiscoverResult success = 1;
   */
  success?: DiscoverResult;
};

/**
 * Describes the message com.gem.router.contract.DiscoverResponse.
 * Use `create(DiscoverResponseSchema)` to create a new message.
 */
export const DiscoverResponseSchema: GenMessage<DiscoverResponse> =
  /*@__PURE__*/
  messageDesc(file_router_router_responses, 7);

/**
 * @generated from message com.gem.router.contract.DiscoverResult
 */
export type DiscoverResult = Message<'com.gem.router.contract.DiscoverResult'> & {
  /**
   * @generated from field: repeated com.gem.router.contract.DiscoverDestination destinations = 1;
   */
  destinations: DiscoverDestination[];
};

/**
 * Describes the message com.gem.router.contract.DiscoverResult.
 * Use `create(DiscoverResultSchema)` to create a new message.
 */
export const DiscoverResultSchema: GenMessage<DiscoverResult> =
  /*@__PURE__*/
  messageDesc(file_router_router_responses, 8);

/**
 * @generated from message com.gem.router.contract.DiscoverDestination
 */
export type DiscoverDestination = Message<'com.gem.router.contract.DiscoverDestination'> & {
  /**
   * @generated from field: com.gem.router.contract.DestinationType type = 1;
   */
  type: DestinationType;

  /**
   * @generated from field: optional string alias = 3;
   */
  alias?: string;

  /**
   * @generated from field: optional com.gem.router.contract.MatchedBy matchedBy = 5;
   */
  matchedBy?: MatchedBy;

  /**
   * @generated from field: optional string matchedValue = 6;
   */
  matchedValue?: string;
};

/**
 * Describes the message com.gem.router.contract.DiscoverDestination.
 * Use `create(DiscoverDestinationSchema)` to create a new message.
 */
export const DiscoverDestinationSchema: GenMessage<DiscoverDestination> =
  /*@__PURE__*/
  messageDesc(file_router_router_responses, 9);

/**
 * @generated from message com.gem.router.contract.DiscoverBaseUrlResponse
 */
export type DiscoverBaseUrlResponse = Message<'com.gem.router.contract.DiscoverBaseUrlResponse'> & {
  /**
   * @generated from field: com.gem.router.contract.DiscoverBaseUrlResult success = 1;
   */
  success?: DiscoverBaseUrlResult;
};

/**
 * Describes the message com.gem.router.contract.DiscoverBaseUrlResponse.
 * Use `create(DiscoverBaseUrlResponseSchema)` to create a new message.
 */
export const DiscoverBaseUrlResponseSchema: GenMessage<DiscoverBaseUrlResponse> =
  /*@__PURE__*/
  messageDesc(file_router_router_responses, 10);

/**
 * @generated from message com.gem.router.contract.DiscoverBaseUrlResult
 */
export type DiscoverBaseUrlResult = Message<'com.gem.router.contract.DiscoverBaseUrlResult'> & {
  /**
   * @generated from field: string baseUrl = 1;
   */
  baseUrl: string;
};

/**
 * Describes the message com.gem.router.contract.DiscoverBaseUrlResult.
 * Use `create(DiscoverBaseUrlResultSchema)` to create a new message.
 */
export const DiscoverBaseUrlResultSchema: GenMessage<DiscoverBaseUrlResult> =
  /*@__PURE__*/
  messageDesc(file_router_router_responses, 11);
